import { Component, OnDestroy, OnInit } from "@angular/core";
import { DialogService } from "@progress/kendo-angular-dialog";
import { MDMService } from "app/reusable/mdm.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { RoleDetailsComponent } from "../roleDetails/role-details.component";
import { RoleGroupModel } from "../models/RoleGroupModel";
import { CedConfirmDialogService } from "ced-ng-library";
import { GroupRolesService } from "../group-roles-note-type.service";

@Component({
  selector: "app-roles-list",
  templateUrl: "./roles-list.component.html",
})
export class RolesListComponent implements OnInit, OnDestroy {
  private _subject$: Subject<boolean> = new Subject();
  roles: RoleGroupModel[] = [];
  itemSelected: RoleGroupModel = null;
  errorPopup: any = null;

  constructor(
    private mdmService: MDMService,
    private dialogService: DialogService,
    private cedConfirmService: CedConfirmDialogService,
    private groupRolesService: GroupRolesService
  ) {}

  ngOnInit(): void {
    this.getGroupRoles();
  }

  getGroupRoles() {
    this.mdmService
      .getGroupRoles()
      .pipe(takeUntil(this._subject$))
      .subscribe(
        (data: any) => {
          this.roles = data;
        }
      );
  }
 

  openDialog(selectedItem) {
    const dialogRef = this.dialogService.open({
      content: RoleDetailsComponent,
    });
    dialogRef.content.instance.selectedItem = selectedItem;
    dialogRef.result.subscribe((r) => {
      this.getGroupRoles();
    });
  }

  dblClickEvent() {
    if (this.itemSelected != null)
      this.mdmService
        .getRoleById(this.itemSelected.id)
        .pipe(takeUntil(this._subject$))
        .subscribe((data: any) => {
          this.itemSelected = data;
          this.openDialog(this.itemSelected);
          this.itemSelected = null;
        });
  }

  onCellClick($event) {
    this.itemSelected = $event.dataItem;
  }

  onDeleteRole(item) {
    this.cedConfirmService
      .show("ARE_YOU_SURE_YOU_WANT_TO_CONTINUE?")
      .pipe(takeUntil(this._subject$))
      .subscribe((res) => {
        if (res.value == true) {
          this.groupRolesService
            .delete(item.id)
            .pipe(takeUntil(this._subject$))
            .subscribe(
              () => {
                this.mdmService
                  .deleteGroupRole(item.id)
                  .pipe(takeUntil(this._subject$))
                  .subscribe(
                    () => {
                      this.roles = [...this.roles.filter((e) => e != item)];
                    }
                  );
              }
            );
        }
      });
  }

  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }

  deleteRoleGroupNoteType(id) {}
}
